import { Hour } from "./hour";
import { Form } from "./forms";
import { SocialLink } from './socialLink';
import { About } from "./about";
import { PictureCardItem } from "./picture-card-item";
import { UnitSizes } from "./unitSizes";
import { AssociationLogo } from "./associationLogo";
import { LocationPortableInfo } from "./locationPortableInfo";
import { NavigationItem } from './navigationItem';
import { Email } from './email';
import { HTMLRow } from './htmlRow';
import { IGoogleTimeZone } from './GoogleTimeZone';

export class LocationInfo {
  insightsHero: {
    title: string,
    subtitle: string,
  };
  heroLeftButtonText: string;
  heroLeftButtonLink: string;
  heroRightButtonText: string;
  heroRightButtonLink: string;
  name: string;
  tagLine: string;
  address: string;
  address2: string;
  phone: string;
  smsPhone: string;
  email: string;
  latitude: number;
  longitude: number;
  hours: Array<Hour>;
  gateHours: Array<Hour>;
  officeHoursText?: string;
  gateHoursText?: string;
  imageUrl: string;
  imageAlt: string;
  imageTitle: string;
  $key: string;
  emailHex?: string;
  ratesHeader?: string;

  navigation?: { [key: string]: NavigationItem };

  payForCheckoutCharges?: boolean;
  checkoutChargesExcludeParkingAndOffice?: boolean;
  checkoutCharges?: any[];

  logoUrl?: string;
  squareLogoUrl?: string;

  noGate: boolean;
  noOffice: boolean;

  showMoveInContract: boolean;
  moveInContractType: string;

  showInsuranceContract: boolean;
  showAutoPayContract: boolean;
  showReserveUnitsOption: boolean;
  showInsuranceOptions: boolean;
  showInsuranceDescriptions = true;
  requireInsurance: boolean;
  allowHomeInsurancePolicy = false;
  showProtectionPlanInstead: boolean;
  hideInsuranceForParkingAndOffices = true;
  hasInsuranceMaxCoverageAmount = true;
  insuranceMaxCoverageAmount = 5001;

  sortParkingLast?: boolean;
  sortByUnitType?: boolean;

  // insuranceHelpText: string;

  gateCodeMinLength: number;
  gateCodeMaxLength: number;
  useGateCodeMaxValue: boolean;
  gateCodeMaxValue?: number;
  useGateCodeMinValue: boolean;
  gateCodeMinValue?: number;
  accessCodeBlurb?: string;

  generateRandomGateCode: boolean;
  parkingVariables: boolean;
  parkingLienInfo: boolean;
  parkingElectricity: boolean;
  reservationFee: boolean;
  showCheckoutItem?: boolean;
  checkoutItem?: string;
  socialLinks: SocialLink[];
  showSocialLinks: boolean;
  leftToolTip: boolean;
  leftToolTipText: string;
  rightToolTip: boolean;
  rightToolTipText: string;
  allowPartialPayments: boolean;
  showAnnouncement: boolean;
  announcementText: string;
  announcementBgColor: string;
  announcementColor: string;
  announcementFontSize: string;

  showCustomerPortalAnnouncement: boolean;
  customerPortalAnnouncementText: string;
  customerPortalAnnouncementBgColor: string;
  customerPortalAnnouncementColor: string;
  customerPortalAnnouncementFontSize: string;

  pushRateStrikethroughPricing?: boolean;
  webRateName?: string;
  showWebRate?: boolean;
  webRateMultiplier?: number;

  climateControlledText?: string;

  showSeparatorbar: boolean = false;
  separatorTitle: string;
  featuresTitle: string;
  featuresSubtitle: string;
  separatorText: string;

  pictureCard: {
    title: string,
    buttonText: string,
    buttonUrl: string,
    cardItem: Array<PictureCardItem>
  };

  ctaUrl: string;
  leftButtonText: string;
  leftButtonLink: string;
  rightButtonText: string;
  rightButtonLink: string;
  ctaTitle: string;
  ctaText: string;

  aboutLocationText: string;
  aboutLocationSidebarSlider: boolean = true;
  aboutLocationSidebarImage: string;
  aboutLocationSidebarImageAlt: string;
  aboutLocationSidebarImageTitle: string;
  aboutLocationFeaturesArray = [];
  locationsCustomSidebarArray = [];

  claimAccountType: string; // gateCode | phoneNumber

  acceptPayments: boolean;
  acceptPaymentsMessage: string;
  prepayMonths: number = 12;

  hideUnits: boolean;
  hideRentals: boolean;
  disableRentals: boolean;
  disableRentalsMessage: string;

  hideCallNow: boolean;
  hideJoinWaitlist: boolean;

  moveInContract: Array<Form>;
  insuranceContract: Array<Form>;
  autoPayContract: Array<Form>;

  state: string;

  moveInLease: any;
  insuranceLease: string;
  helloSignClientId: string;

  isDemo?: boolean;

  siteLinkCorpCode: string;
  siteLinkLocationCode: string;
  siteLinkLocationPw: string;
  siteLinkLicenseKey: string = 'STORAGEPUG4T67WJN34F';
  siteLinkCorpUsername: string;

  uhaulLocationKey: string;
  useUhaulImages: boolean;

  isNoIntegration: boolean;
  disableCustomerPortal: boolean;
  disabledCustomerPortalText: string;

  isSmsReminders: boolean;
  forceSmsOptIn = false;
  isAutoPayAtMoveIn = true;

  enableDiscountBlurb = false;
  discountBlurbText: string;

  smsData: {
    phoneNumber: any,
    dayRentIsDue: number,
    daysBeforeDueToRemind: number,
    showTotal: boolean,
    shortLinkUrl: string,
    linkUrl: string
  };

  sliderUrls: string[] = [];
  showSliderArrows: boolean = false;
  sliderAutoPlay: boolean = true;

  locationBoxSlideshow?: {
    sliderUrls?: Array<string>;
    showSliderArrows?: boolean;
    sliderAutoPlay?: boolean;
  };

  useHtmlRow?: boolean = false;
  replaceUnitsWithHtmlRow?: boolean = false;
  htmlRowHtml?: string;

  useHomePageHtmlRow?: boolean = false;
  htmlHomePageHtmlRowHtml?: string;
  htmlHomePageRows?: Array<HTMLRow>;

  useHtmlRowReserveProcess?: boolean = false;
  htmlRowReserveProcessHtml?: string;

  useHtmlRowRentalProcess?: boolean = false;
  htmlRowRentalProcessHtml?: string;

  videoHeaderUrl?: string;

  useSlideshowInstead?: boolean = false;
  useVideoInstead?: boolean = false;

  rentSummary: string;
  reserveSummary: string;

  rentSuccessMessage: string;
  rentSuccessLine1: string;
  rentSuccessLine2: string;
  reserveSuccessMessage: string;
  reserveSuccessLine1: string;
  reserveSuccessLine2: string;

  reviewLink?: string;

  about?: About;
  sizeGuide: {
    title: string,
    body: string,
    hideButtons?: boolean,
    sizes: Array<UnitSizes>
  };

  metaTitle?: string;
  metaImage?: string;
  metaImageAlt?: string;
  metaDescription?: string;

  unitsPage?: {
    metaTitle?: string;
    metaImage?: string;
    metaImageAlt?: string;
    metaDescription?: string;
  }

  reviewsPage?: {
    pageTitle?: string;
    reviewBlurb?: string;
    reviewLinkUrl?: string;
    metaTitle?: string;
    metaImage?: string;
    metaImageAlt?: string;
    metaDescription?: string;
  };

  loginPageShowMetaData: boolean;

  loginPage?: {
    metaTitle?: string;
    metaImage?: string;
    metaImageAlt?: string;
    metaDescription?: string;
  };

  showMailingAddress = false;
  mailingAddress?: string;
  mailingAddress2?: string;
  mailingAddressBlurb?: string;

  customBlurbRental?: string;
  customBlurbReservation?: string;

  customBlurbInsurance?: string;

  useBoatIconForParking = false;

  portableInfo?= new LocationPortableInfo();

  xpsInfo?: {
    active?: boolean;
    js?: string;
    spanId?: string;
    onclick?: string;
  };

  facebookPixelInfo?: {
    productCatalogId?: boolean;
    active?: boolean;
    id?: string;
  };

  podiumInfo?: {
    active?: boolean;
    apiToken?: string;
  };

  unitFilters = {
    showClimate: false,
    showInside: false,
    showPowerOutlet: false,
    showUnitAlarm: false,
    showGroundFloor: false,
    showFeaturesFilters: true,
    useLocationUnitFilters: false
  };

  spaceInsteadOfUnit = false;

  hideReservationsOnUrgency = false;
  reservationUseShortMoveInForm = true;
  rentalsUseShortMoveInForm = false;
  rentalUseDatePicker?= false;
  reservationUseDatePicker?= false;
  datePickerUseFutureStartDate?= false;
  reservationUseLocationDisabledDays?= false;
  datePickerDisableDays?= [false, false, false, false, false, false, false];
  datePickerFutureStartDate?: Date;
  daysARentalCanBeMadeInAdvance?: number;
  daysReservationIsValid?: number;
  daysAReservationCanBeMadeInAdvance?: number;

  associationLogos?: AssociationLogo[];
  associationTitle: string;
  associationSubtitle: string;

  usePtiCore = false;
  ptiCoreDeviceId?: string;

  useNoke = false;
  nokeId?: string;

  // From Onboarding
  managersName: string;
  numUnits: number;
  occupancyRate: string;
  otherSocial: string;
  onboardingName: string;
  onboardingHours: string;
  onboardingAccessHours: string;
  onboardingKey: string;
  onboardingSitelinkCorpCode: string;
  onboardingSitelinkLocationCode: string;
  onboardingSitelinkUsername: string;
  onboardingSitelinkPassword: string;

  onboardingFeatures: string[];
  onboardingAdditionalFeatures: string;
  onboardingStorageTypes: string[];

  onboardingAdditionalEmails?: Email[];
  hideClientName = false;
  hideChangeNameOnPortal = true;
  hideChangeEmailOnPortal = false;
  disableTenantUpdateInformation = false;
  disabledBulletins = [];

  featuresComponent?: {
    name?: string,
    iconUrl?: string,
    title?: string,
    alt?: string
  }[];

  isNotOpen = false;
  comingSoonInfo = {
    headerDate: '',
    contactUsTitle: '',
    contactUsSubtitle: '',
    title: '',
    imageUrl: '',
    layout: [
      { label: 'Image Left', value: 'imageLeft' }
    ],
    html: ''
  };

  smsReviewLinkUrl?: string;
  sms_review_link_url?: string;

  fullyOccupiedMessageTitle?: string;
  fullyOccupiedMessageSubtitle?: string;
  fullyOccupiedMessageButtonText?: string;

  timezone?: IGoogleTimeZone;

  constructor() {
    this.hours = [];
    this.gateHours = [];
    this.acceptPayments = true;
    this.acceptPaymentsMessage = 'Payments are currently under maintenance. Please call the office to make a payment.';
    this.hideRentals = false;
    this.disableRentals = false;
    this.disableRentalsMessage = '';
    this.smsData = {
      phoneNumber: '18652192552',
      dayRentIsDue: 1,
      daysBeforeDueToRemind: 5,
      showTotal: true,
      shortLinkUrl: '',
      linkUrl: ''
    }
    this.pictureCard = {
      title: 'What storage do you need?',
      buttonText: 'See All Storage Types',
      buttonUrl: '/units',
      cardItem: [
        new PictureCardItem('Self Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Student Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Wine Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Vehicle Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
      ]
    };
    this.moveInContractType = 'pugSign';
    this.claimAccountType = 'gateCode';
    this.noGate = false;
    this.noOffice = false;
    this.moveInContract = [];
    this.showMoveInContract = false;
    this.insuranceContract = [];
    this.showInsuranceContract = false;
    this.isSmsReminders = false;
    this.showInsuranceOptions = false;
    this.useUhaulImages = false;
    this.autoPayContract = [];
    this.showAutoPayContract = false;
    this.showReserveUnitsOption = true;
    this.generateRandomGateCode = false;
    this.socialLinks = [];
    this.showSocialLinks = false;
    this.parkingVariables = false;
    this.parkingLienInfo = false;
    this.parkingElectricity = false;
    this.reservationFee = false;
    this.leftToolTip = false;
    this.rightToolTip = false;
    this.allowPartialPayments = false;
    this.showAnnouncement = false;
    this.announcementBgColor = '#000000';
    this.announcementColor = '#FFF';
    this.announcementFontSize = '14px';
    this.gateHoursText = 'Access Hours';
    this.sizeGuide = {
      title: '',
      body: '',
      hideButtons: false,
      sizes: []
    };
    this.comingSoonInfo = {
      headerDate: '',
      contactUsTitle: '',
      contactUsSubtitle: '',
      title: '',
      imageUrl: '',
      layout: [
        { label: 'Image Left', value: 'imageLeft' }
      ],
      html: ''
    }
    this.locationBoxSlideshow = {
      sliderUrls: [],
      showSliderArrows: false,
      sliderAutoPlay: true
    };
    if (this.name) {
      this.insightsHero = {
        title: this.name,
        subtitle: 'Storage Units in ' + this.address2
      }
    }
    else {
      this.insightsHero = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/locationInfo.ts